// Shared by the settings panel and export. Sparse passes must not inherit
// either backend defaults or the previously selected layer's settings.
export const FILL_DEFAULTS = Object.freeze({
  angle: null, row_spacing_mm: 0.2, max_stitch_length_mm: 3,
  staggers: 4, randomize_stitch_length: false,
  random_stitch_length_jitter_percent: 25,
  pull_compensation_mm: 0.2, expand_mm: 0,
  fill_underlay: true, underlay_type: 'auto',
  fill_underlay_row_spacing_mm: 2, fill_underlay_inset_mm: 0.3,
  fill_underlay_max_stitch_length_mm: 6, fill_underlay_angle: null,
});
export const resolveFillSettings = (pass = {}) => ({
  ...FILL_DEFAULTS,
  ...Object.fromEntries(Object.entries(pass).filter(([, value]) => value !== undefined)),
});
export const isFillPass = (pass = {}) => !['satin', 'running'].includes(pass.stitchType || pass.fill_method);
